export default "__VITE_ASSET__tmWW7L0G__"